import { useEffect, useState } from 'react'
import BannerMain from '@/app/_home/headers/BannerMain'
import AppBottom from '@/app/_home/headers/AppBottom'
import Header from '@/app/_home/headers/Header'
import SearchInput from '@/app/_home/find/SearchInput'
import { useAppContext } from '@context/AppContext'
import { findPortalNamekey } from '../portalSearchClient'

type SearchState = 'idle' | 'searching' | 'not-found' | 'error'

export function PortalHome({ portalCodeKey }: { portalCodeKey: string }) {
  const { context_data } = useAppContext()
  const [searchState, setSearchState] = useState<SearchState>('idle')

  useEffect(() => {
    setSearchState('idle')
  }, [context_data.namekey])

  async function search() {
    if (!context_data.find_enabled || searchState === 'searching' || !portalCodeKey) return
    setSearchState('searching')
    const result = await findPortalNamekey(portalCodeKey, context_data.namekey)
    if (!result.ok) {
      setSearchState('error')
      return
    }
    if (!result.codeKey) {
      setSearchState('not-found')
      return
    }
    window.location.assign(`/${encodeURIComponent(result.codeKey)}`)
  }

  return (
    <div className="flex min-h-[calc(100vh-56px)] w-full flex-col items-center justify-center">
      <Header />
      <div className="flex w-full flex-col items-center justify-center gap-y-0 sm:w-1/2">
        <BannerMain />
        <SearchInput onEnter={() => { void search() }} />
        <div className="my-2 min-h-6 text-base text-[#222]" role="status" aria-live="polite">
          {searchState === 'not-found' ? 'Not found' : null}
          {searchState === 'error' ? 'Search unavailable' : null}
        </div>
        <div className="relative m-2 mt-3 flex h-[58px] w-full max-w-[280px] items-end justify-center">
          <div className="relative z-[2] flex h-12 w-full items-center overflow-hidden rounded-[14px] bg-white shadow">
            <span className="flex h-12 w-11 flex-none items-center justify-center bg-amber-400 text-xl text-gray-600" aria-hidden="true">⌕</span>
            <button
              type="button"
              disabled={!context_data.find_enabled || searchState === 'searching' || !portalCodeKey}
              onClick={() => { void search() }}
              className="flex h-12 min-w-0 flex-1 items-center justify-center gap-2 px-3 text-lg text-black transition-colors disabled:opacity-60 enabled:hover:underline"
            >
              {searchState === 'searching' ? <span className="h-4 w-4 animate-spin rounded-full border-2 border-gray-400 border-t-transparent" aria-hidden="true" /> : null}
              <span>Find msg</span>
            </button>
          </div>
        </div>
        <AppBottom />
      </div>
    </div>
  )
}
